export const formatCategoryData = (rawData, isSlotData = false) => {
  if (!rawData) return [];
  if (isSlotData) {
    return rawData.map((item) => ({
      id: item.entryId || '',
      title: item.title || '',
      link: item.sourceDesktop?.[0]?.hyperlink || item.sourceMobile?.[0]?.hyperlink || '',
      icon: { url: item.sourceDesktop?.[0]?.uri || item.sourceMobile?.[0]?.uri || '' },
      stencilIcon: item.stencilIcon || '',
      entryId: item.entryId || '',
    }));
  }
  return rawData;
};